import React from "react";


import { Col, Row } from "react-bootstrap";


import "./index.scss";


type FormComponentProps = {
    children: React.ReactNode | React.ReactNode[];
    xs?: number; xl?: number;
}


export const FormComponent:React.FC<FormComponentProps> = ({
    children,
    xs = 12, xl
}) => {


    return (
        <Col xs={xs} xl={xl ?? xs} className={'form-component'}>
            <Row className={'form-component__content'}>

                {children}

            </Row>
        </Col>
    );

};


export * from "./@FormHeader";
export * from "./@FormContent";
export * from "./@FormSubmit";

export default FormComponent;
